import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { saveLoginInfo } from "../../../../features/mobile/commonSlice";

const GoogleCallback = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Get JWT token and user info from URL query parameters
    const token = searchParams.get("token");
    const userId = searchParams.get("userId");
    const email = searchParams.get("email");
    const nickName = searchParams.get("nickName");
    const photo = searchParams.get("photo");
    const characterPhoto = searchParams.get("characterPhoto");
    const registrationStep = searchParams.get("registrationStep");
    const error = searchParams.get("error");

    if (error) {
      console.error("Google OAuth error:", error);
      alert(t('login.google_error') + ": " + error);
      navigate('/sign');
      return;
    }

    if (token && userId) {
      // Store JWT token
      localStorage.setItem('accessToken', token);

      // Store Firebase token if available
      const firebaseToken = window.sessionStorage.getItem("token");

      // Save user info to Redux store
      dispatch(
        saveLoginInfo({
          userId: userId,
          nickName: nickName || email?.split('@')[0],
          email: email,
          photo: photo,
          characterPhoto: characterPhoto,
          existPass: true,
        })
      );

      // Check if user needs to complete signup (nickname/character)
      if (registrationStep === 'terms_agreed') {
        // User has agreed to terms but hasn't completed nickname/character
        navigate(`/auth/google-signup?resumeStep=2&userId=${userId}&email=${email}&nickName=${encodeURIComponent(nickName || '')}&photo=${encodeURIComponent(photo || '')}`);
      } else {
        // Registration complete, navigate to home
        navigate('/home');
      }
    } else {
      console.error("Missing token or userId in callback");
      alert(t('login.error_occurred'));
      navigate('/sign');
    }
  }, [dispatch, navigate, searchParams, t]);

  return (
    <div className="flex items-center justify-center h-screen">
      <img src="/images/mobile/splash.svg" alt={t('messages.loading')} />
      <p className="mt-4 text-gray-600">{t('login.processing')}</p>
    </div>
  );
};

export default GoogleCallback;
